import { GwDatesWrapper } from '../components/_internal_date_/gwDatesWrapper';
import { DATE_FORMATS, NEW_DAYS_TO_ADD } from './constants';

const STRINGIFIED_EMPTY_VALUES = ['undefined', 'null'];
const UNSET_KID_AGE = '-';

/**
 * Normalizes a value before it lands in a query string.
 * Missing values — and values that already carry a stringified `undefined`/`null`
 * from a previously built URL — become an empty string, so the API never receives
 * `param=undefined`.
 * @param {*} value
 * @returns {string} Value safe to put in a query string.
 */
export function sanitizeQueryValue(value) {
  if (value === null || value === undefined) return '';

  if (Array.isArray(value)) {
    return value.filter(item => item !== null && item !== undefined && item !== UNSET_KID_AGE).join(',');
  }

  return STRINGIFIED_EMPTY_VALUES.includes(String(value).trim()) ? '' : String(value);
}

export function createSearchString(obj) {
  var str = '';
  for (var key in obj) {
    if (str !== '') {
      str += '&';
    }
    str += key + '=' + encodeURIComponent(sanitizeQueryValue(obj[key]));
  }
  return str;
}

export function validateDates(checkIn, checkOut) {
  let today = GwDatesWrapper.today();
  let arrival = GwDatesWrapper.format(checkIn, DATE_FORMATS.default);
  let departure = GwDatesWrapper.format(checkOut, DATE_FORMATS.default);

  let areOldDates = GwDatesWrapper.isBefore(arrival, today);

  if (areOldDates) {
    // First we get the days diff, to add the days from now on
    let daysToAdd = GwDatesWrapper.diff(today, arrival) + NEW_DAYS_TO_ADD;
    arrival = GwDatesWrapper.add(arrival, daysToAdd);
    departure = GwDatesWrapper.add(departure, daysToAdd);
  }

  return { areOldDates, arrival, departure };
}

export function createSearchStringByRecentSearch(recentSearch, getLocationDataByResortCode) {
  const { lodgeCode } = recentSearch;
  const { url: locationUrl } = getLocationDataByResortCode(lodgeCode);

  const urlOrigin = window.location.origin.toString();

  // Validate dates
  const { areOldDates, arrival, departure } = validateDates(recentSearch.arrival, recentSearch.departure);

  const planQueryStringParams = createSearchString({
    numberOfAdults: recentSearch.numberOfAdults,
    arrival,
    departure,
    offerCode: recentSearch.offerCode,
    kidsAges: recentSearch.kidsAges
  });

  const planSearchString = `${urlOrigin}/${locationUrl}/plan?${planQueryStringParams}`;

  return { planSearchString, areOldDates };
}

/**
 * Create array of detailed package object based on package codes from querystring.
 * @param {Array} packagesCodes - Package codes.
 * @param {Array} availabilityPackages - Package object with rates.
 * @returns {Array} - Detailed package array.
 */

/**
 * Remove spaces and special characters
 * @param {*} text - text to be clean
 * @returns - The text without space or special characters
 */
export const removeSpecialCharactersAndSpaces = text => {
  return text.replace(/[^A-Z0-9]+/gi, '');
};
